export default __webpack_public_path__ + "static/aicpa-ae7e69d646857c39536a2f0c03ef22e3.jpg";